<template>
  <div>
    <h2 v-if="!contentOnly" class="text-center pb-4">{{ $t('message.eCommerceV2.credit.results.resultsTitle') }}</h2>
    <div class="row">
      <div class="col-sm-6 mb-4">
        <template>
          <DropDownCardV2 labelClasses="d-sm-none" class="h-100">
            <template v-slot:header>
              <div class="credit-plus-range-container text-center p-4">
                <h5 class="mb-3">{{ $t('message.credit.equifax.heading') }}</h5>
                <img
                  :alt="creditRangeImage"
                  class="mx-auto d-block py-3"
                  :src="require(`@/assets/credit-range/${creditRangeImage}.svg`)"
                  data-test="creditRangeImage"
                />
                <div class="mt-4 pt-3">
                  <h4 data-test="creditRangeRange">{{ creditRangeRange }}</h4>
                  <img alt="Equifax" width="80" :src="require('@/assets/credit-bureaus/Equifax-Logo.svg')" />
                </div>
              </div>
            </template>
            <template v-slot:label>
              <div class="p-4 border-top">
                <h5 class="text-muted m-0">{{ $t('message.credit.equifax.understandTheScore') }}</h5>
              </div>
            </template>
            <template v-slot:dropdown>
              <div class="px-4 pb-4 d-sm-none">
                <p class="mt-0 small">
                  {{ $t('message.credit.equifax.understandTheScoreMsg') }}
                </p>
                <div class="border-0 h-100">
                  <mobialis-highlighted-list
                    class="small text-dark mb-0"
                    :items="creditRanges"
                    :active-item="creditGrade"
                  >
                  </mobialis-highlighted-list>
                </div>
              </div>
            </template>
          </DropDownCardV2>
        </template>
      </div>
      <div class="col-sm-6 mb-4 d-none d-sm-block">
        <div class="avr-card border-0 h-100">
          <mobialis-highlighted-list class="small text-dark mb-0" :items="creditRanges" :active-item="creditGrade">
          </mobialis-highlighted-list>
        </div>
      </div>
    </div>
    <DropDownCardV2 class="mb-4 d-none d-sm-block">
      <template v-slot:label>
        <div class="p-4">
          <h5 class="m-0">{{ $t('message.credit.equifax.understandTheScore') }}</h5>
        </div>
      </template>
      <template v-slot:dropdown>
        <div class="px-4 pb-4">
          <p class="mt-0 small">{{ $t('message.credit.equifax.understandTheScoreMsg') }}</p>
        </div>
      </template>
    </DropDownCardV2>
    <div v-if="!contentOnly">
      <mobialis-button
        type="submit"
        class="mt-4"
        data-cy="continue"
        @click="goToCreditResults"
        v-av-analytics-cta-interaction="{
          elementText: $t('message.credit.equifax.backToResults'),
          eventActionResult: 'open',
        }"
        >{{ $t('message.credit.equifax.backToResults') }}
      </mobialis-button>
      <p class="mt-2 font-size-10 color-primary-grey text-center">{{ $t('message.credit.disclaimer.equifax') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropDownCardV2 from '@/components/DropDownCardV2.vue';
import { creditRangesMixin } from '@/mixins';

export default {
  name: 'CreditScoreDetails',
  components: {
    DropDownCardV2,
  },
  props: {
    contentOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    suppliedCreditScore: {
      type: String,
      default: null,
    },
  },
  mixins: [creditRangesMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters('credit', ['creditScoreGrade']),
    creditGrade() {
      return this.suppliedCreditScore ? this.suppliedCreditScore : this.creditScoreGrade;
    },
    creditRangeRange() {
      return this.getCreditRangeRange(this.creditGrade);
    },
    creditRangeImage() {
      return `${this.creditGrade}-range`;
    },
  },
  methods: {
    goToCreditResults() {
      this.$router.push({
        name: `credit-results-${this.baseRoute}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-plus-range-container {
  position: relative;
  img {
    max-width: 100%;
  }
  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  h2 {
    font-size: 35px;
    margin: 10px auto 0;
  }
}
</style>
